import {
  EventEmitter,
  Output,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Component,
} from '@angular/core';

@Component({
    selector: 'app-change-quantity',
    templateUrl: './change-quantity.component.html',
    styleUrls: ['./change-quantity.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChangeQuantityComponent implements OnInit {
  @Input() minQuantity: number = 1;
  @Input() maxQuantity?: number;
  @Output() changeQuantity = new EventEmitter<number>();

  @Input() quantity: number | null = null;

  constructor() { }

  ngOnInit(): void {
    this.quantity ??= this.minQuantity;
  }

  onDecreaseQuantity() {
    if (this.quantity > this.minQuantity) {
      this.quantity--;
    }

    this.changeQuantity.emit(this.quantity);
  }

  onIncreaseQuantity() {
    if (!this.maxQuantity || this.quantity < this.maxQuantity) {
      this.quantity++;
    }

    this.changeQuantity.emit(this.quantity);
  }
}
